import { RiTimeLine } from "@remixicon/react";
import { Button } from "@workspace/ui/components/button";
import { Card } from "@workspace/ui/components/card";

interface TimeEmptyStateProps {
	timeLabel?: string;
	selectedDay?: string;
	isFiltered?: boolean;
	onClearFilters?: () => void;
}

export function TimeEmptyState({
	timeLabel,
	selectedDay,
	isFiltered = false,
	onClearFilters,
}: TimeEmptyStateProps) {
	const isTimeSpecific = !!timeLabel && !!selectedDay;

	return (
		<Card className="p-8 text-center">
			<div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
				<RiTimeLine className="h-6 w-6 text-muted-foreground" />
			</div>
			<h3 className="mb-1 font-semibold text-xl">
				{isTimeSpecific ? "No Sets at This Time" : "No Sets Found"}
			</h3>
			<p className="mb-4 text-muted-foreground text-sm">
				{isTimeSpecific && isFiltered
					? `No saved or reviewed sets at ${timeLabel} on ${selectedDay}.`
					: isTimeSpecific
						? `No sets scheduled at ${timeLabel} on ${selectedDay}.`
						: isFiltered
							? "No sets match the current filter settings."
							: "No sets scheduled for this time period."}
			</p>
			{isFiltered && onClearFilters && (
				<div className="mt-4 flex justify-center">
					<Button variant="secondary" size="sm" onClick={onClearFilters}>
						Show All Sets
					</Button>
				</div>
			)}
		</Card>
	);
}
